<template>
  <page-form
    class="subscribe-form"
    action="feedback/send"
    layout="text-aside"
    :use-container="false"
    :form-config="formConfig"
    :submit-label="submitLabel"
    success-title="Благодарим за подписку"
    success-text="Ваша заявка принята и будет рассмотрена в течение 8 рабочих часов"
  >
  </page-form>
</template>

<script>
import PageForm from '@shared/ui/public/forms/PageForm.vue'

export default {
  name: 'SubscribeForm',
  components: { PageForm },
  props: {
    formConfig: {
      type: Object,
    },
    submitLabel: {
      type: String,
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.subscribe-form
  margin-top: 80px
  padding-inline: 41px 105px
  border-radius: $border-radius

  @media (max-width: $tablet-size)
    margin-block: 60px
    padding-inline: 24px

  @media (max-width: $mobile-size)
    margin-inline:  16px
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/SubscribeForm.vue